<template>
  <div class="border d-flex align-items-center justify-content-center">
    <action-button
      v-if="isDaySelected"
      id="calendar-return-btn"
      i="fa fa-arrow-circle-left fa-lg color-gray-2"
      @click="onReturnSelection"
    />
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
export default {
  name: 'AvailabilityCalendarReturn',
  components: {
    ActionButton,
  },
  props: {
    isDaySelected: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    onReturnSelection() {
      this.$emit('return');
    },
  },
};
</script>
<style lang="scss" scoped>
.with-mobile {
  width: 190px !important;
  box-sizing: border-box;
}
</style>
